export const browser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
